// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   Kubersetu Infotech Design System
   Modern Dark Glassmorphism Theme (Unified)
   ========================================== */

:root {
  /* --- Brand Colors (Modernized) --- */
  --color-amber: #F59E0B;
  --color-amber-dark: #D97706;
  --color-orange: #EA580C;
  --color-gold: #FBBF24;
  --color-gold-light: #FDE047;
  
  --color-electric-blue: #0ea5e9;
  --color-neon-cyan: #22d3ee;
  --color-neon-purple: #a855f7;
  --color-emerald: #10B981;
  --color-red: #EF4444;
  --color-blue: #3b82f6;

  /* --- Primary Theme Mappings --- */
  --color-primary: var(--color-amber);
  --color-secondary: var(--color-electric-blue);
  
  /* --- Typography Colors --- */
  --text-main: #F8FAFC;
  --text-muted: #94A3B8;
  --text-dark: #0F172A;

  /* --- Backgrounds --- */
  /* Ultra dark navy for space aesthetic */
  --bg-deep-space: #050814; 
  /* Deep charcoal fallback */
  --color-charcoal: #18181B;
  --color-charcoal-dark: #0F172A;
  
  /* --- Glassmorphism Component Backgrounds --- */
  /* Supports standard components */
  --bg-glass-card: rgba(15, 23, 42, 0.45);
  --bg-glass-card-hover: rgba(15, 23, 42, 0.7);
  
  /* Supports older 'Bento' components */
  --bg-bento-card: var(--bg-glass-card);
  --bg-bento-card-hover: var(--bg-glass-card-hover);

  /* --- Borders --- */
  --border-glass: rgba(255, 255, 255, 0.08);
  --border-glass-hover: rgba(245, 158, 11, 0.3);
  
  --border-bento: var(--border-glass);
  --border-bento-hover: var(--border-glass-hover);

  /* --- Gradients --- */
  --grad-cosmic: linear-gradient(135deg, #F59E0B 0%, #EA580C 100%);
  --grad-primary: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);
  --grad-secondary: linear-gradient(135deg, #0ea5e9 0%, #3b82f6 100%);
  --grad-gold: linear-gradient(135deg, #FDE047 0%, #F59E0B 50%, #EA580C 100%);
  --grad-aurora: radial-gradient(circle at 50% 0%, rgba(245, 158, 11, 0.15) 0%, transparent 70%);
  --grad-success: linear-gradient(135deg, #10B981 0%, #059669 100%);
  --grad-surface: linear-gradient(135deg, rgba(15, 23, 42, 0.8) 0%, rgba(5, 8, 20, 0.95) 100%);
  
  /* --- Typography --- */
  --font-family: 'Outfit', 'Inter', 'Syne', sans-serif;

  /* --- Radii --- */
  --radius-sm: 8px;
  --radius-md: 12px;
  --radius-lg: 20px;
  --radius-xl: 32px;
  --radius-full: 9999px;
  
  --radius-bento: var(--radius-xl);
  --radius-bento-inner: var(--radius-lg);
  --radius-bento-small: var(--radius-md);
  --radius-pill: var(--radius-full);

  /* --- Shadows --- */
  --shadow-sm: 0 4px 6px rgba(0, 0, 0, 0.1);
  --shadow-md: 0 10px 20px rgba(0, 0, 0, 0.3);
  --shadow-lg: 0 20px 40px rgba(0, 0, 0, 0.5);
  --shadow-glow: 0 0 20px rgba(245, 158, 11, 0.2);
  
  --shadow-bento: var(--shadow-lg);
  --shadow-bento-inner: inset 0 1px 0 0 rgba(255, 255, 255, 0.05);
  --shadow-neon: var(--shadow-glow);
  --shadow-amber: 0 8px 25px rgba(245, 158, 11, 0.35);
}

/* ===== Global Reset ===== */
*, *::before, *::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
  font-size: 16px;
}

body {
  font-family: var(--font-family);
  background-color: var(--bg-deep-space);
  color: var(--text-main);
  line-height: 1.6;
  overflow-x: hidden;
  -webkit-font-smoothing: antialiased;
  /* Ambient Grid Background */
  background-image: 
    linear-gradient(rgba(255,255,255,0.015) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,0.015) 1px, transparent 1px);
  background-size: 50px 50px;
}

/* ===== Layout Utility ===== */
.container, .fintech-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* ===== Bento Grid System ===== */
.bento-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
  margin: 2rem 0;
}

.bento-box {
  background: var(--bg-bento-card);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border: 1px solid var(--border-bento);
  border-radius: var(--radius-bento);
  padding: 2.5rem;
  box-shadow: var(--shadow-bento), var(--shadow-bento-inner);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  overflow: hidden;
}

.bento-box:hover {
  transform: translateY(-6px);
  border-color: var(--border-bento-hover);
  box-shadow: var(--shadow-bento), var(--shadow-neon);
  background: var(--bg-bento-card-hover);
  z-index: 2;
}

/* Common Bento Span Classes */
.col-span-1 { grid-column: span 1; }
.col-span-2 { grid-column: span 2; }
.col-span-3 { grid-column: span 3; }
.col-span-4 { grid-column: span 4; }
.row-span-1 { grid-row: span 1; }
.row-span-2 { grid-row: span 2; }

@media (max-width: 1024px) {
  .bento-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .col-span-3, .col-span-4 {
    grid-column: span 2;
  }
}

@media (max-width: 640px) {
  .bento-grid {
    grid-template-columns: 1fr;
  }
  .col-span-1, .col-span-2, .col-span-3, .col-span-4 {
    grid-column: span 1;
  }
}

/* ===== Headings & Headers ===== */
.section-eyebrow, .kubersetu-badge {
  display: inline-block;
  font-size: 0.85rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  color: var(--color-amber);
  background: transparent;
  border: none;
  padding: 0.2rem 0;
  margin-bottom: 0.85rem;
  text-transform: uppercase;
}

.section-header-center, .section-header, .about-hero, .services-header, .loans-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

h1, h2, h3, h4, h5, h6 {
  font-family: var(--font-family);
  font-weight: 800;
  color: #ffffff;
  letter-spacing: -0.02em;
  line-height: 1.2;
}

h1 { font-size: clamp(2.5rem, 5vw, 4.5rem); }
h2 { font-size: clamp(2rem, 4vw, 3rem); }
h3 { font-size: clamp(1.5rem, 2.5vw, 2rem); }

/* ===== Text Gradients ===== */
.gradient-text {
  background: var(--grad-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
}

/* ===== Buttons (Global) ===== */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.85rem 1.75rem;
  border-radius: var(--radius-pill);
  font-family: var(--font-family);
  font-weight: 700;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: none;
  text-decoration: none;
}

.btn-primary {
  background: var(--grad-primary);
  color: #fff;
  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.25);
}

.btn-primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(245, 158, 11, 0.4);
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.05);
  color: var(--text-main);
  border: 1px solid var(--border-glass);
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: var(--color-amber);
  transform: translateY(-3px);
}

.btn-outline {
  background: transparent;
  color: var(--color-amber);
  border: 1px solid var(--color-amber);
}

.btn-outline:hover {
  background: rgba(245, 158, 11, 0.1);
  transform: translateY(-3px);
}

/* ===== Inputs (Global) ===== */
.input-field {
  width: 100%;
  padding: 1rem 1.25rem;
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-sm);
  color: var(--text-main);
  font-family: var(--font-family);
  font-size: 1rem;
  transition: all 0.3s ease;
}

.input-field:focus {
  outline: none;
  border-color: var(--color-amber);
  background: rgba(15, 23, 42, 0.8);
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.15);
}

/* ===== Custom Scrollbar ===== */
::-webkit-scrollbar {
  width: 10px;
}
::-webkit-scrollbar-track {
  background: var(--bg-deep-space);
}
::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: var(--radius-pill);
}
::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.2);
}

/* ===== Fintech Footer ===== */
.fintech-footer {
  background: var(--bg-deep-space);
  padding: 4rem 1.5rem 2rem;
  border-top: 1px solid var(--border-bento);
  color: var(--text-muted);
}

.footer-bento {
  max-width: 1280px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 3rem;
}

@media (max-width: 1024px) {
  .footer-bento {
    grid-template-columns: 1fr 1fr 1fr;
  }
}

@media (max-width: 768px) {
  .footer-bento {
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
  }
  .fintech-footer-desc {
    max-width: 100%;
  }
}

@media (max-width: 480px) {
  .footer-bento {
    grid-template-columns: 1fr;
  }
}

.fintech-footer-brand {
  display: flex;
  flex-direction: column;
}

.fintech-footer-logo {
  display: flex;
}

.fintech-footer-desc {
  font-size: 0.95rem;
  line-height: 1.6;
  max-width: 320px;
  margin-top: 0;
}

.fintech-footer-links ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.fintech-footer-title {
  color: #ffffff;
  font-size: 1.15rem;
  font-weight: 700;
  margin-top: 0;
  margin-bottom: 1.5rem;
}

.fintech-footer-links a {
  color: var(--text-muted);
  text-decoration: none;
  font-size: 0.95rem;
  transition: color 0.3s ease;
}

.fintech-footer-links a:hover {
  color: var(--color-amber);
}

.fintech-footer-bottom {
  grid-column: 1 / -1;
  text-align: center;
  padding-top: 2rem;
  margin-top: 1rem;
  border-top: 1px solid var(--border-bento);
}

.fintech-footer-bottom p {
  font-size: 0.85rem;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/Global.css"],"names":[],"mappings":"AAAA;;;+CAG+C;;AAE/C;EACE,sCAAsC;EACtC,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;;EAE3B,8BAA8B;EAC9B,0BAA0B;EAC1B,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;;EAErB,mCAAmC;EACnC,mCAAmC;EACnC,6CAA6C;;EAE7C,8BAA8B;EAC9B,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;;EAEpB,wBAAwB;EACxB,wCAAwC;EACxC,wBAAwB;EACxB,2BAA2B;EAC3B,yBAAyB;EACzB,8BAA8B;;EAE9B,gDAAgD;EAChD,iCAAiC;EACjC,uCAAuC;EACvC,4CAA4C;;EAE5C,sCAAsC;EACtC,qCAAqC;EACrC,iDAAiD;;EAEjD,oBAAoB;EACpB,yCAAyC;EACzC,6CAA6C;;EAE7C,mCAAmC;EACnC,+CAA+C;;EAE/C,sBAAsB;EACtB,gEAAgE;EAChE,iEAAiE;EACjE,mEAAmE;EACnE,2EAA2E;EAC3E,8FAA8F;EAC9F,iEAAiE;EACjE,4FAA4F;;EAE5F,uBAAuB;EACvB,oDAAoD;;EAEpD,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;;EAErB,gCAAgC;EAChC,sCAAsC;EACtC,sCAAsC;EACtC,iCAAiC;;EAEjC,oBAAoB;EACpB,yCAAyC;EACzC,2CAA2C;EAC3C,2CAA2C;EAC3C,+CAA+C;;EAE/C,gCAAgC;EAChC,+DAA+D;EAC/D,iCAAiC;EACjC,mDAAmD;AACrD;;AAEA,6BAA6B;AAC7B;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,sCAAsC;EACtC,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,4BAA4B;EAC5B;;wEAEsE;EACtE,0BAA0B;AAC5B;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,mCAAmC;EACnC,qCAAqC;EACrC,kCAAkC;EAClC,eAAe;EACf,0DAA0D;EAC1D,4DAA4D;EAC5D,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;EACvC,mDAAmD;EACnD,sCAAsC;EACtC,UAAU;AACZ;;AAEA,8BAA8B;AAC9B,cAAc,mBAAmB,EAAE;AACnC,cAAc,mBAAmB,EAAE;AACnC,cAAc,mBAAmB,EAAE;AACnC,cAAc,mBAAmB,EAAE;AACnC,cAAc,gBAAgB,EAAE;AAChC,cAAc,gBAAgB,EAAE;;AAEhC;EACE;IACE,qCAAqC;EACvC;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,mCAAmC;AACnC;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,KAAK,qCAAqC,EAAE;AAC5C,KAAK,iCAAiC,EAAE;AACxC,KAAK,qCAAqC,EAAE;;AAE5C,+BAA+B;AAC/B;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,iCAAiC;AACjC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,wBAAwB;EACxB,iCAAiC;EACjC,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iDAAiD;EACjD,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,qBAAqB;EACrB,iCAAiC;EACjC,qCAAqC;EACrC,+BAA+B;EAC/B,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,iCAAiC;EACjC,8CAA8C;AAChD;;AAEA,iCAAiC;AACjC;EACE,WAAW;AACb;AACA;EACE,gCAAgC;AAClC;AACA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;AACA;EACE,oCAAoC;AACtC;;AAEA,+BAA+B;AAC/B;EACE,gCAAgC;EAChC,yBAAyB;EACzB,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sCAAsC;EACtC,SAAS;AACX;;AAEA;EACE;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,8BAA8B;IAC9B,SAAS;EACX;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX","sourcesContent":["/* ==========================================\n   Kubersetu Infotech Design System\n   Modern Dark Glassmorphism Theme (Unified)\n   ========================================== */\n\n:root {\n  /* --- Brand Colors (Modernized) --- */\n  --color-amber: #F59E0B;\n  --color-amber-dark: #D97706;\n  --color-orange: #EA580C;\n  --color-gold: #FBBF24;\n  --color-gold-light: #FDE047;\n  \n  --color-electric-blue: #0ea5e9;\n  --color-neon-cyan: #22d3ee;\n  --color-neon-purple: #a855f7;\n  --color-emerald: #10B981;\n  --color-red: #EF4444;\n  --color-blue: #3b82f6;\n\n  /* --- Primary Theme Mappings --- */\n  --color-primary: var(--color-amber);\n  --color-secondary: var(--color-electric-blue);\n  \n  /* --- Typography Colors --- */\n  --text-main: #F8FAFC;\n  --text-muted: #94A3B8;\n  --text-dark: #0F172A;\n\n  /* --- Backgrounds --- */\n  /* Ultra dark navy for space aesthetic */\n  --bg-deep-space: #050814; \n  /* Deep charcoal fallback */\n  --color-charcoal: #18181B;\n  --color-charcoal-dark: #0F172A;\n  \n  /* --- Glassmorphism Component Backgrounds --- */\n  /* Supports standard components */\n  --bg-glass-card: rgba(15, 23, 42, 0.45);\n  --bg-glass-card-hover: rgba(15, 23, 42, 0.7);\n  \n  /* Supports older 'Bento' components */\n  --bg-bento-card: var(--bg-glass-card);\n  --bg-bento-card-hover: var(--bg-glass-card-hover);\n\n  /* --- Borders --- */\n  --border-glass: rgba(255, 255, 255, 0.08);\n  --border-glass-hover: rgba(245, 158, 11, 0.3);\n  \n  --border-bento: var(--border-glass);\n  --border-bento-hover: var(--border-glass-hover);\n\n  /* --- Gradients --- */\n  --grad-cosmic: linear-gradient(135deg, #F59E0B 0%, #EA580C 100%);\n  --grad-primary: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);\n  --grad-secondary: linear-gradient(135deg, #0ea5e9 0%, #3b82f6 100%);\n  --grad-gold: linear-gradient(135deg, #FDE047 0%, #F59E0B 50%, #EA580C 100%);\n  --grad-aurora: radial-gradient(circle at 50% 0%, rgba(245, 158, 11, 0.15) 0%, transparent 70%);\n  --grad-success: linear-gradient(135deg, #10B981 0%, #059669 100%);\n  --grad-surface: linear-gradient(135deg, rgba(15, 23, 42, 0.8) 0%, rgba(5, 8, 20, 0.95) 100%);\n  \n  /* --- Typography --- */\n  --font-family: 'Outfit', 'Inter', 'Syne', sans-serif;\n\n  /* --- Radii --- */\n  --radius-sm: 8px;\n  --radius-md: 12px;\n  --radius-lg: 20px;\n  --radius-xl: 32px;\n  --radius-full: 9999px;\n  \n  --radius-bento: var(--radius-xl);\n  --radius-bento-inner: var(--radius-lg);\n  --radius-bento-small: var(--radius-md);\n  --radius-pill: var(--radius-full);\n\n  /* --- Shadows --- */\n  --shadow-sm: 0 4px 6px rgba(0, 0, 0, 0.1);\n  --shadow-md: 0 10px 20px rgba(0, 0, 0, 0.3);\n  --shadow-lg: 0 20px 40px rgba(0, 0, 0, 0.5);\n  --shadow-glow: 0 0 20px rgba(245, 158, 11, 0.2);\n  \n  --shadow-bento: var(--shadow-lg);\n  --shadow-bento-inner: inset 0 1px 0 0 rgba(255, 255, 255, 0.05);\n  --shadow-neon: var(--shadow-glow);\n  --shadow-amber: 0 8px 25px rgba(245, 158, 11, 0.35);\n}\n\n/* ===== Global Reset ===== */\n*, *::before, *::after {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n  font-size: 16px;\n}\n\nbody {\n  font-family: var(--font-family);\n  background-color: var(--bg-deep-space);\n  color: var(--text-main);\n  line-height: 1.6;\n  overflow-x: hidden;\n  -webkit-font-smoothing: antialiased;\n  /* Ambient Grid Background */\n  background-image: \n    linear-gradient(rgba(255,255,255,0.015) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(255,255,255,0.015) 1px, transparent 1px);\n  background-size: 50px 50px;\n}\n\n/* ===== Layout Utility ===== */\n.container, .fintech-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n/* ===== Bento Grid System ===== */\n.bento-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1.5rem;\n  margin: 2rem 0;\n}\n\n.bento-box {\n  background: var(--bg-bento-card);\n  backdrop-filter: blur(24px);\n  -webkit-backdrop-filter: blur(24px);\n  border: 1px solid var(--border-bento);\n  border-radius: var(--radius-bento);\n  padding: 2.5rem;\n  box-shadow: var(--shadow-bento), var(--shadow-bento-inner);\n  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  position: relative;\n  overflow: hidden;\n}\n\n.bento-box:hover {\n  transform: translateY(-6px);\n  border-color: var(--border-bento-hover);\n  box-shadow: var(--shadow-bento), var(--shadow-neon);\n  background: var(--bg-bento-card-hover);\n  z-index: 2;\n}\n\n/* Common Bento Span Classes */\n.col-span-1 { grid-column: span 1; }\n.col-span-2 { grid-column: span 2; }\n.col-span-3 { grid-column: span 3; }\n.col-span-4 { grid-column: span 4; }\n.row-span-1 { grid-row: span 1; }\n.row-span-2 { grid-row: span 2; }\n\n@media (max-width: 1024px) {\n  .bento-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .col-span-3, .col-span-4 {\n    grid-column: span 2;\n  }\n}\n\n@media (max-width: 640px) {\n  .bento-grid {\n    grid-template-columns: 1fr;\n  }\n  .col-span-1, .col-span-2, .col-span-3, .col-span-4 {\n    grid-column: span 1;\n  }\n}\n\n/* ===== Headings & Headers ===== */\n.section-eyebrow, .kubersetu-badge {\n  display: inline-block;\n  font-size: 0.85rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  color: var(--color-amber);\n  background: transparent;\n  border: none;\n  padding: 0.2rem 0;\n  margin-bottom: 0.85rem;\n  text-transform: uppercase;\n}\n\n.section-header-center, .section-header, .about-hero, .services-header, .loans-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-family: var(--font-family);\n  font-weight: 800;\n  color: #ffffff;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n}\n\nh1 { font-size: clamp(2.5rem, 5vw, 4.5rem); }\nh2 { font-size: clamp(2rem, 4vw, 3rem); }\nh3 { font-size: clamp(1.5rem, 2.5vw, 2rem); }\n\n/* ===== Text Gradients ===== */\n.gradient-text {\n  background: var(--grad-primary);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  display: inline-block;\n}\n\n/* ===== Buttons (Global) ===== */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.85rem 1.75rem;\n  border-radius: var(--radius-pill);\n  font-family: var(--font-family);\n  font-weight: 700;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  border: none;\n  text-decoration: none;\n}\n\n.btn-primary {\n  background: var(--grad-primary);\n  color: #fff;\n  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.25);\n}\n\n.btn-primary:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 8px 25px rgba(245, 158, 11, 0.4);\n}\n\n.btn-secondary {\n  background: rgba(255, 255, 255, 0.05);\n  color: var(--text-main);\n  border: 1px solid var(--border-glass);\n}\n\n.btn-secondary:hover {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: var(--color-amber);\n  transform: translateY(-3px);\n}\n\n.btn-outline {\n  background: transparent;\n  color: var(--color-amber);\n  border: 1px solid var(--color-amber);\n}\n\n.btn-outline:hover {\n  background: rgba(245, 158, 11, 0.1);\n  transform: translateY(-3px);\n}\n\n/* ===== Inputs (Global) ===== */\n.input-field {\n  width: 100%;\n  padding: 1rem 1.25rem;\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-sm);\n  color: var(--text-main);\n  font-family: var(--font-family);\n  font-size: 1rem;\n  transition: all 0.3s ease;\n}\n\n.input-field:focus {\n  outline: none;\n  border-color: var(--color-amber);\n  background: rgba(15, 23, 42, 0.8);\n  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.15);\n}\n\n/* ===== Custom Scrollbar ===== */\n::-webkit-scrollbar {\n  width: 10px;\n}\n::-webkit-scrollbar-track {\n  background: var(--bg-deep-space);\n}\n::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: var(--radius-pill);\n}\n::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n/* ===== Fintech Footer ===== */\n.fintech-footer {\n  background: var(--bg-deep-space);\n  padding: 4rem 1.5rem 2rem;\n  border-top: 1px solid var(--border-bento);\n  color: var(--text-muted);\n}\n\n.footer-bento {\n  max-width: 1280px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr 1fr;\n  gap: 3rem;\n}\n\n@media (max-width: 1024px) {\n  .footer-bento {\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .footer-bento {\n    grid-template-columns: 1fr 1fr;\n    gap: 2rem;\n  }\n  .fintech-footer-desc {\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .footer-bento {\n    grid-template-columns: 1fr;\n  }\n}\n\n.fintech-footer-brand {\n  display: flex;\n  flex-direction: column;\n}\n\n.fintech-footer-logo {\n  display: flex;\n}\n\n.fintech-footer-desc {\n  font-size: 0.95rem;\n  line-height: 1.6;\n  max-width: 320px;\n  margin-top: 0;\n}\n\n.fintech-footer-links ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.fintech-footer-title {\n  color: #ffffff;\n  font-size: 1.15rem;\n  font-weight: 700;\n  margin-top: 0;\n  margin-bottom: 1.5rem;\n}\n\n.fintech-footer-links a {\n  color: var(--text-muted);\n  text-decoration: none;\n  font-size: 0.95rem;\n  transition: color 0.3s ease;\n}\n\n.fintech-footer-links a:hover {\n  color: var(--color-amber);\n}\n\n.fintech-footer-bottom {\n  grid-column: 1 / -1;\n  text-align: center;\n  padding-top: 2rem;\n  margin-top: 1rem;\n  border-top: 1px solid var(--border-bento);\n}\n\n.fintech-footer-bottom p {\n  font-size: 0.85rem;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
